/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Load_TitleInputs */



/**
* | output |
* | --- |
* | "Load Transcript Export Preset" |
*
* @param {Transcript_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_load_title = /** @type {((inputs?: Transcript_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger un prereglage d'exportation de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung zum Laden des Transkripts Exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica preimpostazione di esportazione della trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузить предустановку экспорта транскрипта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar ajuste preestablecido de exportación de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载转录导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトエクスポートプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट एक्सपोर्ट प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar transcrição Exportar predefinição")
	return /** @type {LocalizedString} */ ("Load Transcript Export Preset")
});